export const GET_STAFFS_LIST = null;
export const SELECTED_STAFF_ID = null;
export const SELECTED_STAFF_ID_FOR_UPDATE_ORDER_STATUS = null;
export const GET_STAFF_BY_ID = null;
export const GET_STAFFS_SELECT_LIST = null;
export const GET_STAFFS_SELECT_LIST_FOR_REQUESTS = null;
export const GET_REQUEST_STAFF_LIST = null;
export const CLEAR_TEMP_STAFF = null;
export const SELECTED_STAFF_RENEWAL_DETAILS = null;